module.exports = __webpack_public_path__ + "img/AsiaIIXLogo.a7b4a4c5.png";